import useSelectedShop from './useSelectedShop';
import { useClaimsShopSettings } from '../components/parcel-finder/ClaimsShopSettingsContext';

export default function useHasClaimsAccess(): boolean {
  const shop = useSelectedShop();
  const { isClaimsEnabled: hasClaimableCarriers } = useClaimsShopSettings();

  return !!shop?.isClaimsEnabled || !!hasClaimableCarriers;
}
